import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import BrandIntro from "./components/BrandIntro";
import Testimonials from "./components/Testimonials";
import ContactSection from "./components/ContactSection";

export default function About() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料社区",
    url: "https://heiliaoshequ.cn",
    description: "黑料社区是一个专注于热点事件追踪与深度分析的资讯平台。我们致力于打破信息壁垒，为公众提供真实、全面、有深度的资讯内容。",
    email: "contact@heiliaoshequ.cn",
    telephone: "+86-400-888-8888",
    address: {
      "@type": "PostalAddress",
      streetAddress: "建国路100号传媒大厦15层",
      addressLocality: "北京",
      addressRegion: "朝阳区",
      addressCountry: "CN",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "黑料社区的内容来源是什么？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "黑料社区的内容主要来自我们专业编辑团队的原创调查报道，同时也接收来自社会各界的爆料和投稿。所有内容在发布前都会经过严格的核实流程，确保信息的准确性和可靠性。",
        },
      },
      {
        "@type": "Question",
        name: "如何向黑料社区提供新闻线索？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过我们的联系邮箱 contact@heiliaoshequ.cn 或网站留言表单提交新闻线索。我们承诺对所有爆料人信息严格保密，并对有价值的线索给予相应报酬。",
        },
      },
      {
        "@type": "Question",
        name: "黑料社区的文章是否支持转载？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "黑料社区的所有原创内容均受版权保护。如需转载，请通过官方邮箱联系我们获取授权。未经授权的转载行为，我们将保留追究法律责任的权利。",
        },
      },
      {
        "@type": "Question",
        name: "如何加入黑料社区的编辑团队？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们长期招聘具有调查报道经验的记者和编辑。如果您对深度报道有热情，欢迎将简历和代表作品发送至 contact@heiliaoshequ.cn，我们会在7个工作日内回复。",
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title="关于我们 - 黑料社区"
        description="了解黑料社区的团队背景、品牌理念和发展历程。黑料社区致力于提供真实、全面、有深度的资讯内容，守护公众知情权。"
        keywords="关于黑料社区,品牌介绍,用户口碑,联系我们,爆料平台,深度分析"
        canonicalUrl="https://heiliaoshequ.cn/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </div>
        <BrandIntro />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}